(function () {
  var originalFetch = window.fetch;
  var giftOfferSyncPromise = null;
  var giftOfferSyncQueued = false;

  function getRequestUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource && typeof resource.url === 'string') return resource.url;
    return '';
  }

  function getRequestMethod(resource, config) {
    return String((config && config.method) || (resource && resource.method) || 'GET').toUpperCase();
  }

  function isCartMutation(resource, config) {
    var method = getRequestMethod(resource, config);
    if (method !== 'POST') return false;

    var requestUrl = getRequestUrl(resource);
    if (!requestUrl) return false;

    try {
      var url = new URL(requestUrl, window.location.origin);
      return url.pathname.indexOf('/cart/add') === 0 || url.pathname.indexOf('/cart/change') === 0;
    } catch (error) {
      return requestUrl.indexOf('/cart/add') !== -1 || requestUrl.indexOf('/cart/change') !== -1;
    }
  }

  function initGiftPopup(popup) {
    if (!popup || popup.dataset.initialized === 'true') return;

    var closePopup = function () {
      popup.classList.remove('active');
      popup.setAttribute('inert', '');

      window.setTimeout(function () {
        if (!popup.classList.contains('active')) {
          popup.hidden = true;
        }
      }, 350);
    };

    var closeBtn = popup.querySelector('.strap-popup-close');
    var overlay = popup.querySelector('.strap-popup-overlay');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePopup();
    });

    popup.dataset.initialized = 'true';
  }

  function ensureGiftPopup() {
    var popup = document.getElementById('strap-gift-popup');
    if (popup) {
      initGiftPopup(popup);
      return popup;
    }

    var template = document.getElementById('strap-gift-popup-template');
    if (!template || !template.content || !template.content.firstElementChild) return null;

    popup = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(popup);
    initGiftPopup(popup);
    return popup;
  }

  function openGiftPopup() {
    var popup = ensureGiftPopup();
    if (!popup) return;

    popup.hidden = false;
    popup.removeAttribute('inert');

    window.requestAnimationFrame(function () {
      popup.classList.add('active');
      var closeBtn = popup.querySelector('.strap-popup-close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }

  function syncGiftOffer() {
    return originalFetch.call(window, '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var strapCount = 0;
        var walletCount = 0;

        cart.items.forEach(function (item) {
          var properties = item.properties || {};

          if (properties._is_strap === 'true') {
            strapCount += item.quantity;
          }

          if (properties._is_wallet === 'true') {
            walletCount += item.quantity;
          }
        });

        localStorage.setItem('strapCount', strapCount);
        localStorage.setItem('walletCount', walletCount);

        if (strapCount >= 3 && walletCount < 1) {
          openGiftPopup();
        }
      })
      .catch(function () {
        // Keep cart actions working even if the gift-offer sync fails.
      });
  }

  function scheduleGiftOfferSync() {
    if (giftOfferSyncPromise) {
      giftOfferSyncQueued = true;
      return;
    }

    giftOfferSyncPromise = syncGiftOffer().finally(function () {
      giftOfferSyncPromise = null;

      if (giftOfferSyncQueued) {
        giftOfferSyncQueued = false;
        scheduleGiftOfferSync();
      }
    });
  }

  if (typeof originalFetch === 'function') {
    window.fetch = function (resource, config) {
      var shouldSyncGiftOffer = isCartMutation(resource, config || {});

      return originalFetch.apply(this, arguments).then(function (response) {
        if (shouldSyncGiftOffer) {
          scheduleGiftOfferSync();
        }

        return response;
      });
    };
  }
})();

(function () {
  var cleanupTimer = null;

  function getRect(element) {
    try {
      return element.getBoundingClientRect();
    } catch (error) {
      return { width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0 };
    }
  }

  function isVisible(element) {
    if (!element) return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number.parseFloat(style.opacity || '1') < 0.05) {
      return false;
    }

    var rect = getRect(element);
    return rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight;
  }

  function isKlaviyoOverlay(element) {
    if (!element || !element.classList || !element.classList.contains('needsclick')) return false;

    var style = window.getComputedStyle(element);
    if (style.position !== 'fixed') return false;

    var rect = getRect(element);
    var coversViewport = rect.width >= window.innerWidth * 0.8 && rect.height >= window.innerHeight * 0.8;
    if (!coversViewport) return false;

    var className = String(element.className || '').toLowerCase();
    return className.indexOf('kl-private-reset') !== -1 || Boolean(element.querySelector('.klaviyo-form'));
  }

  function hasVisibleKlaviyoDialog(overlay) {
    var dialogSelectors = [
      '.klaviyo-form',
      'form',
      'input[type="email"]',
      'button[aria-label*="Close" i]',
      'button[aria-label*="close" i]',
      '[role="dialog"]',
    ];

    return dialogSelectors.some(function (selector) {
      return Array.from(overlay.querySelectorAll(selector)).some(isVisible);
    });
  }

  function cleanupBrokenKlaviyoOverlays() {
    Array.from(document.querySelectorAll('.needsclick')).forEach(function (overlay) {
      if (!isKlaviyoOverlay(overlay)) return;
      if (hasVisibleKlaviyoDialog(overlay)) return;

      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.display = 'none';
      overlay.style.pointerEvents = 'none';
    });
  }

  function scheduleCleanup(delay) {
    window.setTimeout(cleanupBrokenKlaviyoOverlays, delay);
  }

  function queueCleanup(delay) {
    window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(cleanupBrokenKlaviyoOverlays, delay);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;

      var closeControl = event.target.closest(
        '.needsclick button[aria-label*="close" i], .needsclick button[aria-label*="Close" i], .needsclick [role="button"][aria-label*="close" i]'
      );

      if (closeControl) scheduleCleanup(700);
    },
    true
  );

  window.addEventListener('DOMContentLoaded', function () {
    scheduleCleanup(2500);
    scheduleCleanup(5000);
    scheduleCleanup(9000);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        queueCleanup(400);
      });

      observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden'],
      });
    }
  });
})();
